import { client } from './client'

const trimObjectValues = (obj) => {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (typeof obj === 'string') {
    return obj.trim()
  }

  if (Array.isArray(obj)) {
    return obj.map(trimObjectValues)
  }

  if (typeof obj === 'object') {
    const trimmedObj = {}
    Object.keys(obj).forEach((key) => {
      trimmedObj[key] = trimObjectValues(obj[key])
    })
    return trimmedObj
  }

  return obj
}

const attachParams = (resource, params) => {
  if (Object.keys(params.filter).length) {
    const filters = []
    Object.keys(params.filter).forEach((key) => {
      let value = params.filter[key]
      if (typeof value === 'string') {
        value = value.trim()
      }

      if (value === '' || value === null || value === undefined) {
        return
      }

      switch (key) {
        case 'status':
          filters.push(`_status=${value}`)
          break
        case 'q':
          filters.push(`q=${value}`)
          break
        case '_order':
          filters.push(`_order=${value}`)
          break
        case 'requisitionFilter':
          filters.push(`requisitionFilter=${value}`)
          break
        case 'providerId':
          filters.push(`_provider=${value}`)
          break
        case 'shopifyOrderNumber':
          filters.push(`_shopifyOrderNumber=${value}`)
          break
        case 'pp_search':
          filters.push(`pp_search=${value}`)
          break
        case 'pp_tags':
          filters.push(`pp_tags=${value}`)
          break
        case 'email':
          filters.push(`_email=${value}`)
          break
        case 'patientName':
          filters.push(`_patientName=${value}`)
          break
        case 'requestStatus':
          filters.push(`_requestStatus=${value}`)
          break
        case 'providerGroupId':
          filters.push(`_providerGroupId=${value}`)
          break
        case 'providerLocationId':
          filters.push(`_providerLocationId=${value}`)
          break
        case 'name':
          filters.push(`_name=${value}`)
          break
        case 'locationName':
          filters.push(`_locationName=${value}`)
          break
        case 'clinicName':
          filters.push(`_clinicName=${encodeURIComponent(value)}`)
          break
        case 'createdDate':
          filters.push(`_createdDate=${value}`)
          break
        case 'patientDob':
          filters.push(`_patientDob=${value}`)
          break
        case 'requestId':
          filters.push(`_requestId=${encodeURIComponent(value)}`)
          break
        case 'shippedInvoiceId':
          filters.push(`_shippedInvoiceId=${encodeURIComponent(value)}`)
          break
        case 'testedInvoiceId':
          filters.push(`_testedInvoiceId=${encodeURIComponent(value)}`)
          break
        case 'billingPeriod':
          filters.push(`_billingPeriod=${value}`)
          break
        default:
          filters.push(`${key}=${value}`)
          break
      }
    })

    resource += `?${filters.join('&')}`
  }

  return resource
}

const dataProvider = {
  getList: (resource, params) => {
    if (resource === 'kit-requests') {
      const { page, perPage } = params.pagination
      const paginatedParams = {
        ...params,
        filter: {
          ...params.filter,
          _pageSize: perPage,
          _page: page,
        },
      }
      const newResource = attachParams(resource, paginatedParams)
      return client()
        .get(newResource)
        .then((res) => res.data)
    }
    const newResource = attachParams(resource, params)
    return client()
      .get(newResource, params)
      .then((res) => {
        return res.data
      })
  },
  getOne: (resource, params) => {
    if (resource === 'notification-settings') {
      return client().get(resource).then((res) => {
        const record = res.data.data.find((r) => r.id === params.id)
        return { data: record }
      })
    }
    return client().get(`${resource}/${params.id}`, params)
  },
  getMany: (resource, params) => {
    // resolve api calls and then put responses in format expected by react-admin
    return client()
      .put(`${resource}/many`, params)
      .then((res) => {
        return {
          data: res.data,
        }
      })
  },
  getManyReference: (resource, _params) => {
    return client().get(resource)
  },
  update: (resource, params) => {
    const trimmedData = trimObjectValues(params.data)
    return client().put(`${resource}/${params.id}`, trimmedData)
  },
  updateMany: (resource, params) => {
    const trimmedParams = {
      ...params,
      data: trimObjectValues(params.data),
    }
    return client().put(`${resource}/many`, trimmedParams)
  },
  create: (resource, _params) => {
    const trimmedData = trimObjectValues(_params.data)
    return client().post(resource, trimmedData)
  },
  delete: (resource, params) => {
    return client().delete(`${resource}/${params.id}`, params)
  },
  deleteMany: (resource, params) => {
    return params.ids.map((id) => {
      return client().put(`${resource}/${id}`, params)
    })
  },
}

export default dataProvider
